var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6902 9.17969H17.9202C18.4333 9.17969 18.6941 9.80153 18.3352 10.1676C18.3348 10.168 18.3344 10.1684 18.3341 10.1688L15.1267 13.3761L13.1567 15.3461C12.5219 15.9809 11.4885 15.9809 10.8538 15.3461L5.67379 10.1661C5.30785 9.80019 5.567 9.17969 6.08024 9.17969H11.6902Z",
    fill: "#8C90A5",
    stroke: "#8C90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e08b578fb3bb1a3993795711ad245160.svg";
export { ForwardRef as ReactComponent };